import { render } from "./ProfileNav.vue?vue&type=template&id=bb511294&scoped=true"
import script from "./ProfileNav.vue?vue&type=script&lang=js"
export * from "./ProfileNav.vue?vue&type=script&lang=js"

import "./ProfileNav.vue?vue&type=style&index=0&id=bb511294&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb511294"]])

export default __exports__